<div class="container-fluid ptp-wrapper">
    <div class="d-flex justify-content-between align-items-center">
        <h3>Applications</h3>
        <mat-button-toggle-group (change)="onFilterChange($event)" [disabled]="isLoading">
            <mat-button-toggle value="all" checked>All Applications</mat-button-toggle>
            <mat-button-toggle value="my">My Applications</mat-button-toggle>
            <mat-button-toggle value="open">Open Applications</mat-button-toggle>
        </mat-button-toggle-group>
    </div>
    <div class="d-flex justify-content-between align-items-center">
        <form [formGroup]="form" class="w-75">
            <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
        </form>
        <div class="page">
            <mat-icon matListItemIcon class="arrow" [class.disabled]="page === 1 ||  isLoading"
                (click)="onPrevPage()">arrow_left</mat-icon>
            <span>{{(page - 1) * perPage + 1}} - {{(page - 1) * perPage + count}}</span>
            <mat-icon matListItemIcon class="arrow" [class.disabled]="!hasMoreRecord ||  isLoading"
                (click)="onNextPage()">arrow_right</mat-icon>
        </div>
    </div>
    <div style="height: calc(100% - 150px)">
        <!-- Single state display - handles both loading and empty -->
        <app-state-display *ngIf="isLoading || (!isLoading && applications.length === 0)" style="height: 100%"
            [type]="isLoading ? 'loading' : 'empty'" loadingMessage="Loading applications..."
            emptyMessage="No applications found" emptyIcon="assignment">
        </app-state-display>

        <!-- Table content -->
        <app-custom-table *ngIf="!isLoading && applications.length > 0" class="ag-theme-material"
            style="width: 100%; height: 100%" [rowData]="applications" [columnDefs]="columns" [animateRows]="true"
            [pagination]="false" [hideGlobalFilter]="true" (cellClicked)="onCellClicked($event)">
        </app-custom-table>
        <div class="page">
            <mat-icon matListItemIcon class="arrow" [class.disabled]="page === 1 ||  isLoading"
                (click)="onPrevPage()">arrow_left</mat-icon>
            <span>{{(page - 1) * perPage + 1}} - {{(page - 1) * perPage + count}}</span>
            <mat-icon matListItemIcon class="arrow" [class.disabled]="!hasMoreRecord ||  isLoading"
                (click)="onNextPage()">arrow_right</mat-icon>
        </div>
    </div>
</div>